import { createReducer, on } from '@ngrx/store';
import * as KlaviyoActions from '../actions/klaviyo.action';

export interface KlaviyoState {
  email: string;
  productIds: string[];
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: KlaviyoState = {
  email: '',
  productIds: [],
  loaded: false,
  loading: false,
};

export const klaviyoReducer = createReducer(
  initialState,
  on(KlaviyoActions.SubscribeBackInStock, (state, { email, productId }) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(KlaviyoActions.SubscribeBackInStockSuccess, (state, { email, productId }) => {
    return {
      ...state,
      email,
      productIds: [...state.productIds, productId],
      loaded: true,
      loading: false,
    };
  }),
  on(KlaviyoActions.SubscribeBackInStockFail, (state, { error }) => {
    return {
      ...state,
      error,
      loading: false,
    };
  }),
  on(KlaviyoActions.LoadKlaviyoSubscribedProductIds, state => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(KlaviyoActions.LoadKlaviyoSubscribedProductIdsSuccess, (state, { email, productIds }) => {
    return {
      ...state,
      email,
      productIds,
      loaded: true,
      loading: false,
    };
  }),
  on(KlaviyoActions.LoadKlaviyoSubscribedProductIdsFail, (state, { error }) => {
    return {
      ...state,
      error,
      loading: false,
    };
  }),
  on(KlaviyoActions.ResetKlaviyoState, () => {
    return {
      ...initialState,
    };
  })
);

export const getKlaviyoState = (state: KlaviyoState) => state;
